// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/scrollbars.module.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../pages/discovery/DiscoveryAddDialog.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* A node's widgets (#662): the Widgets tab, and the tags dragged into code.
   Colours, radii and fonts are the tokens in styles/curioTokens.css. Tags,
   fields and buttons share one height, --widget-h, so a row's tag, control
   and buttons line up. */

/* A widget's tag: the same rounded box as its chip in the code
   (widgetReferences.css). */
.Hw3knxjXkoasYimILvye {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: 22px;
  padding: 0 8px;
  border: 1px solid #b6cbf2;
  border-radius: var(--curio-radius-sm);
  background: var(--curio-accent-sky-bg);
  color: var(--curio-accent-sky-fg);
  font-family: var(--curio-font-mono);
  font-size: var(--curio-font-size-xs);
  font-weight: 500;
  white-space: nowrap;
  cursor: grab;
  user-select: none;
}

.Hw3knxjXkoasYimILvye:active {
  cursor: grabbing;
}

.Hw3knxjXkoasYimILvye:focus-visible {
  outline: 2px solid var(--curio-role-update-fg);
  outline-offset: 1px;
}

/* The header above a node's code or spec: one row of categories, then the
   chips of each open one, a line each, in the row's order. On the canvas it
   takes at most half of the node's editor, so the code or spec keeps its room;
   in a notebook cell, whose editor is as tall as its content, it takes what
   its chips need. */
.UlaUSx5jsT2JEMDf9vLa {
  display: flex;
  flex: none;
  flex-direction: column;
  gap: 4px;
  max-height: 50%;
  padding: 4px 8px;
  border-bottom: 1px solid var(--curio-border);
  background: var(--curio-card-bg);
}

/* The open categories' chips, under the row: they scroll when the header is as
   tall as it gets. */
.rN1SGZ_JtqIN0jMjK1OF {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 0;
  overflow-y: auto;
}

.vAUiALMdztjA9XNf0rdz {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

/* A category: its name, its count and a chevron, darker while open. */
.a5t1Qz84qUpxpYbAs1at {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  box-sizing: border-box;
  height: 22px;
  padding: 0 6px;
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-sm);
  background: var(--curio-card-bg);
  color: var(--curio-text-secondary);
  font-family: var(--curio-font-family);
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
}

.a5t1Qz84qUpxpYbAs1at:hover {
  border-color: var(--curio-border-strong);
  color: var(--curio-text-primary);
}

.a5t1Qz84qUpxpYbAs1at[aria-expanded="true"] {
  border-color: var(--curio-border-strong);
  background: var(--curio-surface-muted);
  color: var(--curio-text-primary);
}

.a5t1Qz84qUpxpYbAs1at:focus-visible {
  outline: 2px solid var(--curio-role-update-fg);
  outline-offset: 1px;
}

.K446mLsFiqyfwLFohFnZ {
  font-weight: 400;
  font-variant-numeric: tabular-nums;
}

/* The chevron of every expander: a category's points down while closed and up
   while open, an input line's right while closed and down while open. */
.EFMMbVFQqqr6eNKAALRm {
  display: block;
  flex: none;
}

/* An open category's tags: one row, in order. */
.y1zXlkdeQAp9hdj8ll_B {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

/* Inputs: a line per input, each open list under its own line. */
.tr4gOK_DeZDK8Fi22t7m {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* A line under Inputs: its expander, its tag, then what its input holds. */
.ciJBdXeWLOUWwQOaSs1i {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

/* A line's expander: a square button in the inputs' green, pressed while its
   list is open. */
.YC6jANxWKBx3Fx00WGIb {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  box-sizing: border-box;
  width: 22px;
  height: 22px;
  padding: 0;
  border: 1px solid #a8d5b1;
  border-radius: var(--curio-radius-sm);
  background: var(--curio-card-bg);
  color: var(--curio-accent-mint-fg);
  cursor: pointer;
}

.YC6jANxWKBx3Fx00WGIb:hover {
  border-color: var(--curio-accent-mint-fg);
  background: var(--curio-accent-mint-bg);
}

.YC6jANxWKBx3Fx00WGIb[aria-expanded="true"] {
  background: #cfe9d5;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);
}

.YC6jANxWKBx3Fx00WGIb:focus-visible {
  outline: 2px solid var(--curio-role-update-fg);
  outline-offset: 1px;
}

/* What a line's input holds, muted, cut short with an ellipsis on a narrow
   node. */
.pBcbtOu9GzIy0phr7E9_ {
  min-width: 0;
  overflow: hidden;
  color: var(--curio-text-secondary);
  font-size: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* An open list, under its own line and past its expander: the expander's width
   and the line's gap. */
.bp7puGbP4sZapmLuIw24 {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 28px;
}

/* A list's chips: an input's columns, a layer's, or the fields of inputs. */
.T3s88faYVjwnkkCUpPXs {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

/* A layered input's list: a line per layer, its tag and then its columns, one
   grid, so the layers' tags line up in one column, which gives way on a narrow
   node. */
.wSt0H3EF_QSJmLuwexYK {
  display: grid;
  grid-template-columns: minmax(0, max-content) minmax(0, 1fr);
  gap: 4px 6px;
}

.Utaj4VZRYtz0RilX80vO {
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  align-items: start;
}

.jsthTKfRYHcRDxsa_FLW {
  font-size: 10px;
  color: var(--curio-text-secondary);
  margin-right: 2px;
}

/* A layer with no columns says so after its tag, on the tag's line. */
.NuL91Qbsyi9DGthmG7Zu {
  line-height: 22px;
}

/* An input's tag and its columns (#662): green, like their chips in the code. */
.oWlBgUBH_KewimTPvaQQ {
  border-color: #a8d5b1;
  background: var(--curio-accent-mint-bg);
  color: var(--curio-accent-mint-fg);
}

/* A layer's tag, first on its line, as wide as its name, cut short with an
   ellipsis on a narrow node. */
.ieG6teMw_zGNdeWiSZfA {
  display: block;
  justify-self: start;
  max-width: 100%;
  overflow: hidden;
  line-height: 20px;
  text-overflow: ellipsis;
}

/* A selection tag, the ids a view's selection picks: peach, like its chips. */
.lToJOoLLGPnz4ZvmuoDF {
  border-color: #f2b9a3;
  background: var(--curio-accent-peach-bg);
  color: #b8461d;
}

/* A column's tag, or a field's of inputs: green on white, cut short with an
   ellipsis when it is wider than its list. */
.Yu6FbHmakG1imzheSugT {
  display: block;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  border-color: #a8d5b1;
  background: var(--curio-card-bg);
  color: var(--curio-accent-mint-fg);
  line-height: 20px;
  text-overflow: ellipsis;
}

/* A scenario chip's tag (#662), under Scenarios: lilac, like its chip in the
   spec. The boxes' swatches are one such tag, the scale of the scenarios'
   colors, and an input's tag shows the swatch of its color. */
.W1aPrkdVwxZz28YUyBmk {
  gap: 5px;
  border-color: #cdbff0;
  background: var(--curio-accent-lilac-bg);
  color: var(--curio-accent-lilac-fg);
}

.lzlZCxRfh2MUU3RtQ_Ou {
  gap: 6px;
}

.KfF8r5oL63_LWmhhdJvj {
  display: inline-flex;
  align-items: center;
  gap: 3px;
}

.WrD9dWF4IOom5PiIUDEP {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2);
}

/* A node's Widgets tab and a dashboard tile's controls. A panel that holds
   more than it shows scrolls with the Data Catalog's thin scrollbar. */
.bpkehqfEODOlO1QN9GL4 {
  --widget-h: 22px;
  height: 100%;
  padding: 8px 10px;
  overflow-y: auto;
  font-family: var(--curio-font-family);
  font-size: var(--curio-font-size-xs);
  color: var(--curio-text-primary);
}

/* WidgetsEditor.css gives every label a right margin. Not a label Material UI
   draws in a widget's own control (WidgetControl): a choice's label, whose
   margins the widget theme sets, and the file button. */
/* A tile's controls above its chart or map: their own height, at most half
   the tile, so the output below keeps the rest. */
.ClFme15r1XZyMr_iuW0x {
  flex: none;
  height: auto;
  max-height: 50%;
}

.bpkehqfEODOlO1QN9GL4 label:not(.MuiFormControlLabel-root):not(.MuiButton-root) {
  margin: 0;
}

/* Not a widget's own control (WidgetControl), which Material UI draws: its
   field has its own border and height. */
.bpkehqfEODOlO1QN9GL4 input[type="text"]:not(.MuiInputBase-input),
.bpkehqfEODOlO1QN9GL4 input[type="number"]:not(.MuiInputBase-input),
.bpkehqfEODOlO1QN9GL4 input[type="search"]:not(.MuiInputBase-input),
.bpkehqfEODOlO1QN9GL4 input[type="datetime-local"]:not(.MuiInputBase-input),
.bpkehqfEODOlO1QN9GL4 input[type="date"]:not(.MuiInputBase-input),
.bpkehqfEODOlO1QN9GL4 select:not(.MuiInputBase-input) {
  box-sizing: border-box;
  height: var(--widget-h);
  min-width: 0;
  padding: 0 6px;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-sm);
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  font-family: inherit;
  font-size: var(--curio-font-size-xs);
  box-shadow: none;
}

.bpkehqfEODOlO1QN9GL4 input:not(.MuiInputBase-input):focus,
.bpkehqfEODOlO1QN9GL4 select:not(.MuiInputBase-input):focus {
  outline: 2px solid var(--curio-role-update-fg);
  outline-offset: -1px;
  box-shadow: none;
}

.bpkehqfEODOlO1QN9GL4 input[type="checkbox"],
.bpkehqfEODOlO1QN9GL4 input[type="radio"] {
  margin: 0;
}

.bpkehqfEODOlO1QN9GL4 input[type="range"] {
  height: var(--widget-h);
  margin: 0;
}

.bpkehqfEODOlO1QN9GL4 input[type="file"] {
  font-size: var(--curio-font-size-xs);
}

.FfV8X7RI2HfoviMbeccE {
  color: var(--curio-text-secondary);
  margin: 0 0 8px;
}

/* One widget: its label above the control, then the tag, the control and
   the buttons on one line. A control that takes several lines (a checkbox
   group, a location) grows below that line. */
.NuS4kKSe9ctzycR6tQ6c {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  grid-template-areas:
    ". label ."
    "tag control actions";
  column-gap: 8px;
  row-gap: 2px;
  align-items: start;
  padding: 6px 0;
  border-bottom: 1px solid var(--curio-border);
}

/* A dashboard tile's control: its label above it, with no tag and no buttons. */
.exWlUePopfY08Djtqhfu {
  grid-template-columns: minmax(0, 1fr);
  grid-template-areas:
    "label"
    "control";
}

.NuS4kKSe9ctzycR6tQ6c > .Hw3knxjXkoasYimILvye {
  grid-area: tag;
}

/* Controls of the node's own under its widgets' rows (Data Export's Download),
   at the right, as the rows' controls end. */
.Vn_4GmKHOBm5V1YN_tFa {
  display: flex;
  justify-content: flex-end;
  padding: 6px 0;
}

.A8qCF8S48Vw5q2WAoM4w {
  grid-area: label;
  overflow: hidden;
  color: var(--curio-text-secondary);
  font-size: 10px;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.CaD2ZXE_JRxEw_tvOWvL {
  grid-area: control;
  min-width: 0;
}

.zF0sHyA8eWo3DZkR1k3K {
  grid-area: actions;
  display: flex;
  gap: 4px;
}

/* The node's selection tags, below its own widgets (SelectionTags): each with
   what it holds. */
.qsdI__DpZl1XPYVCXuvl {
  margin-top: 10px;
}

.dmSi7YYo7TAp0BnvB8wP {
  margin: 0;
  color: var(--curio-text-secondary);
  font-size: 10px;
  font-weight: 600;
}

.j00eMdjlEHQdttFPJIsh {
  grid-area: control;
  min-width: 0;
  overflow: hidden;
  font-family: var(--curio-font-mono);
  line-height: var(--widget-h);
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* A selection tag that holds no ids it can give: too many, or a deleted view. */
.IM6JbsDaG59zWzSI3veR {
  grid-area: control;
  min-width: 0;
  color: var(--curio-danger-text);
  line-height: 1.3;
}

.bTd4pTQ5_qjB8Td_s2xz {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.bTd4pTQ5_qjB8Td_s2xz > input[type="text"],
.bTd4pTQ5_qjB8Td_s2xz > input[type="number"],
.bTd4pTQ5_qjB8Td_s2xz > input[type="datetime-local"],
.bTd4pTQ5_qjB8Td_s2xz > input[type="date"],
.bTd4pTQ5_qjB8Td_s2xz > select {
  width: 100%;
}

.Zaq5Er8laFIS_A0SseRw {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  min-height: var(--widget-h);
}

.Zaq5Er8laFIS_A0SseRw > input[type="number"],
.Zaq5Er8laFIS_A0SseRw > input[type="range"] {
  flex: 1;
  width: auto;
  min-width: 0;
}

.mi1axHtq8RIAf1V8hu9g {
  white-space: nowrap;
  color: var(--curio-text-secondary);
}

/* A dataset widget: where a file or a Data Catalog dataset is dropped, naming
   the dataset it holds. Its node takes the drop, and outlines it while a drop
   is over the node. */
.ygou_4aiQHLOmEp6tvln {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  min-height: var(--widget-h);
  padding: 4px 6px;
  border: 1px dashed var(--curio-border-strong);
  border-radius: 6px;
}

.l9ZAK7pLemBGga3Gb0Ww {
  border-style: solid;
  border-color: var(--curio-category-data-fg);
  background: var(--curio-category-data-bg);
}

.o5V8RMWDTjXBaXk22ioQ {
  flex: 1;
  overflow: hidden;
  min-width: 0;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hdnPFCnfRpLNyBHY7sAW {
  flex: 1;
  min-width: 0;
  color: var(--curio-text-secondary);
}

.aD4ZMz5UzdrHUDabIaOc {
  display: flex;
  flex-wrap: wrap;
  gap: 0 10px;
}

.aD4ZMz5UzdrHUDabIaOc .bc0R4HoK2ZUZCGgaBDgw {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  height: var(--widget-h);
  color: var(--curio-text-primary);
  font-size: var(--curio-font-size-xs);
  font-weight: normal;
}

.W1xLpy5ElEBNiV7Tdxdr {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.C565MGxRv3QsFRW6XVYF {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.RvMQIzixFksSmP0PxIgw {
}

.cUW50wTmpbqquwr1_xiA {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

/* The place search the Discovery dialog shares, at this tab's size. */
.cUW50wTmpbqquwr1_xiA > div {
  gap: 4px;
  font-size: var(--curio-font-size-xs);
}

.cUW50wTmpbqquwr1_xiA > div > button {
  box-sizing: border-box;
  height: var(--widget-h);
  padding: 0 8px;
  font-size: var(--curio-font-size-xs);
}

.cUW50wTmpbqquwr1_xiA p {
  margin: 0;
  font-size: 10px;
}

.FuSO1SBVzZPY1FPubVX8 {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 120px;
  overflow-y: auto;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-sm);
}

.FuSO1SBVzZPY1FPubVX8 button {
  width: 100%;
  padding: 3px 6px;
  border: 0;
  background: none;
  color: var(--curio-text-primary);
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.FuSO1SBVzZPY1FPubVX8 button:hover {
  background: var(--curio-surface-muted);
}

.QeHGBJZ39XC5ltWDLFzi {
  color: var(--curio-text-secondary);
}

/* Buttons, at this tab's size: a white one, a dark one for the main action
   (as ConfirmDialog's), and a red-text one for Delete. */
.GIGzxLs_5GQy6yXqbmEn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  height: var(--widget-h);
  padding: 0 8px;
  border: 1px solid var(--curio-border-strong);
  border-radius: var(--curio-radius-sm);
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  font-family: inherit;
  font-size: var(--curio-font-size-xs);
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}

.GIGzxLs_5GQy6yXqbmEn:hover:not(:disabled) {
  border-color: var(--curio-text-secondary);
}

.GIGzxLs_5GQy6yXqbmEn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.lU7E5MEFPpdzqjf2aJhn {
  border-color: var(--curio-top-bar-bg);
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
  font-weight: 600;
}

.lU7E5MEFPpdzqjf2aJhn:hover:not(:disabled) {
  border-color: var(--curio-top-bar-bg-hover);
  background: var(--curio-top-bar-bg-hover);
}

.hkvh7XWgqv2uv7BbV8MM {
  color: var(--curio-danger-text);
}

.hkvh7XWgqv2uv7BbV8MM:hover:not(:disabled) {
  border-color: var(--curio-danger-border);
  background: var(--curio-danger-bg);
}

.kYMKqwfYAUIwRO58h4G3 {
  margin-top: 8px;
}

.oK1IKvieY9Urw9SqLy3Q {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 6px 0;
  padding: 8px;
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-md);
  background: var(--curio-card-bg);
  box-shadow: var(--curio-shadow-card);
}

/* A field's name above its input. Not a label Material UI draws in the
   default's control, which keeps its own row. */
.oK1IKvieY9Urw9SqLy3Q label:not(.MuiFormControlLabel-root):not(.MuiButton-root),
.TEMccfVsuVWXjCzyNEpR {
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: var(--curio-text-secondary);
  font-size: 10px;
}

.Bu9KBcw_JW1Ow2OBxk1W {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}

.qenbRU8eRTDN67R0yxzd {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}

.b3j61ONOKKC1KjjK4ANz {
  color: var(--curio-danger-text);
  margin: 0;
}

.sTssxmof4cksU1TzF8Pb {
  color: var(--curio-danger-text);
  margin: 8px 0 0;
  padding-left: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/editing/widgets/WidgetTags.module.css"],"names":[],"mappings":"AAAA;;;yBAGyB;;AAEzB;4BAC4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,qCAAqC;EACrC,sCAAsC;EACtC,iCAAiC;EACjC,mCAAmC;EACnC,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;;;;oBAIoB;AACpB;EACE,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;qBACqB;AACrB;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA,sEAAsE;AACtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,qCAAqC;EACrC,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;wEACwE;AACxE;EACE,cAAc;EACd,UAAU;AACZ;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;kBACkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,qCAAqC;EACrC,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;UACU;AACV;EACE,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;wBACwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;UAEU;AACV;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA,sEAAsE;AACtE;EAEE,iBAAiB;AACnB;;AAEA,gFAAgF;AAChF;EAEE,qBAAqB;EACrB,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;+BAC+B;AAC/B;EAEE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,8EAA8E;AAC9E;EAEE,qBAAqB;EACrB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;6CAC6C;AAC7C;EAEE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,kCAAkC;EAClC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;8DAE8D;AAC9D;EAEE,QAAQ;EACR,qBAAqB;EACrB,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EAEE,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;uEACuE;AACvE;EAEE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;wDAEwD;AACxD;kDACkD;AAClD;EACE,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;yCACyC;AACzC;;;;;;EAME,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;EAChC,gCAAgC;EAChC,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;;EAEE,8CAA8C;EAC9C,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;;8CAE8C;AAC9C;EACE,aAAa;EACb,+CAA+C;EAC/C;;yBAEuB;EACvB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,4CAA4C;AAC9C;;AAEA,gFAAgF;AAChF;EACE,qCAAqC;EACrC;;aAEW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;6CAC6C;AAC7C;EACE,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;AACV;;AAEA;mBACmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;EACnC,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;;;;;EAKE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;EAEE,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;;sBAEsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,gCAAgC;EAChC,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;AAEA;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,sEAAsE;AACtE;EACE,QAAQ;EACR,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;yDACyD;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;EAChC,gCAAgC;EAChC,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EAEE,qCAAqC;EACrC,mCAAmC;EACnC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;gDACgD;AAChD;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["/* A node's widgets (#662): the Widgets tab, and the tags dragged into code.\n   Colours, radii and fonts are the tokens in styles/curioTokens.css. Tags,\n   fields and buttons share one height, --widget-h, so a row's tag, control\n   and buttons line up. */\n\n/* A widget's tag: the same rounded box as its chip in the code\n   (widgetReferences.css). */\n.tag {\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  height: 22px;\n  padding: 0 8px;\n  border: 1px solid #b6cbf2;\n  border-radius: var(--curio-radius-sm);\n  background: var(--curio-accent-sky-bg);\n  color: var(--curio-accent-sky-fg);\n  font-family: var(--curio-font-mono);\n  font-size: var(--curio-font-size-xs);\n  font-weight: 500;\n  white-space: nowrap;\n  cursor: grab;\n  user-select: none;\n}\n\n.tag:active {\n  cursor: grabbing;\n}\n\n.tag:focus-visible {\n  outline: 2px solid var(--curio-role-update-fg);\n  outline-offset: 1px;\n}\n\n/* The header above a node's code or spec: one row of categories, then the\n   chips of each open one, a line each, in the row's order. On the canvas it\n   takes at most half of the node's editor, so the code or spec keeps its room;\n   in a notebook cell, whose editor is as tall as its content, it takes what\n   its chips need. */\n.strip {\n  display: flex;\n  flex: none;\n  flex-direction: column;\n  gap: 4px;\n  max-height: 50%;\n  padding: 4px 8px;\n  border-bottom: 1px solid var(--curio-border);\n  background: var(--curio-card-bg);\n}\n\n/* The open categories' chips, under the row: they scroll when the header is as\n   tall as it gets. */\n.stripOpen {\n  composes: thinScrollbar from \"../../../styles/scrollbars.module.css\";\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.categories {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n}\n\n/* A category: its name, its count and a chevron, darker while open. */\n.category {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  box-sizing: border-box;\n  height: 22px;\n  padding: 0 6px;\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-sm);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-secondary);\n  font-family: var(--curio-font-family);\n  font-size: 10px;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.category:hover {\n  border-color: var(--curio-border-strong);\n  color: var(--curio-text-primary);\n}\n\n.category[aria-expanded=\"true\"] {\n  border-color: var(--curio-border-strong);\n  background: var(--curio-surface-muted);\n  color: var(--curio-text-primary);\n}\n\n.category:focus-visible {\n  outline: 2px solid var(--curio-role-update-fg);\n  outline-offset: 1px;\n}\n\n.categoryCount {\n  font-weight: 400;\n  font-variant-numeric: tabular-nums;\n}\n\n/* The chevron of every expander: a category's points down while closed and up\n   while open, an input line's right while closed and down while open. */\n.chevron {\n  display: block;\n  flex: none;\n}\n\n/* An open category's tags: one row, in order. */\n.categoryChips {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Inputs: a line per input, each open list under its own line. */\n.categoryStack {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* A line under Inputs: its expander, its tag, then what its input holds. */\n.inputLine {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n/* A line's expander: a square button in the inputs' green, pressed while its\n   list is open. */\n.expand {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: none;\n  box-sizing: border-box;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  border: 1px solid #a8d5b1;\n  border-radius: var(--curio-radius-sm);\n  background: var(--curio-card-bg);\n  color: var(--curio-accent-mint-fg);\n  cursor: pointer;\n}\n\n.expand:hover {\n  border-color: var(--curio-accent-mint-fg);\n  background: var(--curio-accent-mint-bg);\n}\n\n.expand[aria-expanded=\"true\"] {\n  background: #cfe9d5;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15);\n}\n\n.expand:focus-visible {\n  outline: 2px solid var(--curio-role-update-fg);\n  outline-offset: 1px;\n}\n\n/* What a line's input holds, muted, cut short with an ellipsis on a narrow\n   node. */\n.inputAbout {\n  min-width: 0;\n  overflow: hidden;\n  color: var(--curio-text-secondary);\n  font-size: 10px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n/* An open list, under its own line and past its expander: the expander's width\n   and the line's gap. */\n.inputList {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-left: 28px;\n}\n\n/* A list's chips: an input's columns, a layer's, or the fields of inputs. */\n.listChips {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px;\n}\n\n/* A layered input's list: a line per layer, its tag and then its columns, one\n   grid, so the layers' tags line up in one column, which gives way on a narrow\n   node. */\n.layers {\n  display: grid;\n  grid-template-columns: minmax(0, max-content) minmax(0, 1fr);\n  gap: 4px 6px;\n}\n\n.layerLine {\n  display: grid;\n  grid-column: 1 / -1;\n  grid-template-columns: subgrid;\n  align-items: start;\n}\n\n.stripHint {\n  font-size: 10px;\n  color: var(--curio-text-secondary);\n  margin-right: 2px;\n}\n\n/* A layer with no columns says so after its tag, on the tag's line. */\n.layerEmpty {\n  composes: stripHint;\n  line-height: 22px;\n}\n\n/* An input's tag and its columns (#662): green, like their chips in the code. */\n.inputTag {\n  composes: tag;\n  border-color: #a8d5b1;\n  background: var(--curio-accent-mint-bg);\n  color: var(--curio-accent-mint-fg);\n}\n\n/* A layer's tag, first on its line, as wide as its name, cut short with an\n   ellipsis on a narrow node. */\n.layerTag {\n  composes: inputTag;\n  display: block;\n  justify-self: start;\n  max-width: 100%;\n  overflow: hidden;\n  line-height: 20px;\n  text-overflow: ellipsis;\n}\n\n/* A selection tag, the ids a view's selection picks: peach, like its chips. */\n.selectionTag {\n  composes: tag;\n  border-color: #f2b9a3;\n  background: var(--curio-accent-peach-bg);\n  color: #b8461d;\n}\n\n/* A column's tag, or a field's of inputs: green on white, cut short with an\n   ellipsis when it is wider than its list. */\n.columnTag {\n  composes: tag;\n  display: block;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  border-color: #a8d5b1;\n  background: var(--curio-card-bg);\n  color: var(--curio-accent-mint-fg);\n  line-height: 20px;\n  text-overflow: ellipsis;\n}\n\n/* A scenario chip's tag (#662), under Scenarios: lilac, like its chip in the\n   spec. The boxes' swatches are one such tag, the scale of the scenarios'\n   colors, and an input's tag shows the swatch of its color. */\n.scenarioTag {\n  composes: tag;\n  gap: 5px;\n  border-color: #cdbff0;\n  background: var(--curio-accent-lilac-bg);\n  color: var(--curio-accent-lilac-fg);\n}\n\n.swatches {\n  composes: scenarioTag;\n  gap: 6px;\n}\n\n.swatch {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n}\n\n.swatchColor {\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2);\n}\n\n/* A node's Widgets tab and a dashboard tile's controls. A panel that holds\n   more than it shows scrolls with the Data Catalog's thin scrollbar. */\n.panel {\n  composes: thinScrollbar from \"../../../styles/scrollbars.module.css\";\n  --widget-h: 22px;\n  height: 100%;\n  padding: 8px 10px;\n  overflow-y: auto;\n  font-family: var(--curio-font-family);\n  font-size: var(--curio-font-size-xs);\n  color: var(--curio-text-primary);\n}\n\n/* WidgetsEditor.css gives every label a right margin. Not a label Material UI\n   draws in a widget's own control (WidgetControl): a choice's label, whose\n   margins the widget theme sets, and the file button. */\n/* A tile's controls above its chart or map: their own height, at most half\n   the tile, so the output below keeps the rest. */\n.panelAboveOutput {\n  flex: none;\n  height: auto;\n  max-height: 50%;\n}\n\n.panel label:not(:global(.MuiFormControlLabel-root)):not(:global(.MuiButton-root)) {\n  margin: 0;\n}\n\n/* Not a widget's own control (WidgetControl), which Material UI draws: its\n   field has its own border and height. */\n.panel input[type=\"text\"]:not(:global(.MuiInputBase-input)),\n.panel input[type=\"number\"]:not(:global(.MuiInputBase-input)),\n.panel input[type=\"search\"]:not(:global(.MuiInputBase-input)),\n.panel input[type=\"datetime-local\"]:not(:global(.MuiInputBase-input)),\n.panel input[type=\"date\"]:not(:global(.MuiInputBase-input)),\n.panel select:not(:global(.MuiInputBase-input)) {\n  box-sizing: border-box;\n  height: var(--widget-h);\n  min-width: 0;\n  padding: 0 6px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-sm);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  font-family: inherit;\n  font-size: var(--curio-font-size-xs);\n  box-shadow: none;\n}\n\n.panel input:not(:global(.MuiInputBase-input)):focus,\n.panel select:not(:global(.MuiInputBase-input)):focus {\n  outline: 2px solid var(--curio-role-update-fg);\n  outline-offset: -1px;\n  box-shadow: none;\n}\n\n.panel input[type=\"checkbox\"],\n.panel input[type=\"radio\"] {\n  margin: 0;\n}\n\n.panel input[type=\"range\"] {\n  height: var(--widget-h);\n  margin: 0;\n}\n\n.panel input[type=\"file\"] {\n  font-size: var(--curio-font-size-xs);\n}\n\n.empty {\n  color: var(--curio-text-secondary);\n  margin: 0 0 8px;\n}\n\n/* One widget: its label above the control, then the tag, the control and\n   the buttons on one line. A control that takes several lines (a checkbox\n   group, a location) grows below that line. */\n.row {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  grid-template-areas:\n    \". label .\"\n    \"tag control actions\";\n  column-gap: 8px;\n  row-gap: 2px;\n  align-items: start;\n  padding: 6px 0;\n  border-bottom: 1px solid var(--curio-border);\n}\n\n/* A dashboard tile's control: its label above it, with no tag and no buttons. */\n.plainRow {\n  grid-template-columns: minmax(0, 1fr);\n  grid-template-areas:\n    \"label\"\n    \"control\";\n}\n\n.row > .tag {\n  grid-area: tag;\n}\n\n/* Controls of the node's own under its widgets' rows (Data Export's Download),\n   at the right, as the rows' controls end. */\n.nodeControls {\n  display: flex;\n  justify-content: flex-end;\n  padding: 6px 0;\n}\n\n.rowLabel {\n  grid-area: label;\n  overflow: hidden;\n  color: var(--curio-text-secondary);\n  font-size: 10px;\n  line-height: 1.3;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.rowControl {\n  grid-area: control;\n  min-width: 0;\n}\n\n.rowActions {\n  grid-area: actions;\n  display: flex;\n  gap: 4px;\n}\n\n/* The node's selection tags, below its own widgets (SelectionTags): each with\n   what it holds. */\n.shared {\n  margin-top: 10px;\n}\n\n.sharedHeading {\n  margin: 0;\n  color: var(--curio-text-secondary);\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.sharedValue {\n  grid-area: control;\n  min-width: 0;\n  overflow: hidden;\n  font-family: var(--curio-font-mono);\n  line-height: var(--widget-h);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* A selection tag that holds no ids it can give: too many, or a deleted view. */\n.selectionProblem {\n  grid-area: control;\n  min-width: 0;\n  color: var(--curio-danger-text);\n  line-height: 1.3;\n}\n\n.control {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.control > input[type=\"text\"],\n.control > input[type=\"number\"],\n.control > input[type=\"datetime-local\"],\n.control > input[type=\"date\"],\n.control > select {\n  width: 100%;\n}\n\n.inline {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  min-height: var(--widget-h);\n}\n\n.inline > input[type=\"number\"],\n.inline > input[type=\"range\"] {\n  flex: 1;\n  width: auto;\n  min-width: 0;\n}\n\n.units {\n  white-space: nowrap;\n  color: var(--curio-text-secondary);\n}\n\n/* A dataset widget: where a file or a Data Catalog dataset is dropped, naming\n   the dataset it holds. Its node takes the drop, and outlines it while a drop\n   is over the node. */\n.datasetDrop {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  min-height: var(--widget-h);\n  padding: 4px 6px;\n  border: 1px dashed var(--curio-border-strong);\n  border-radius: 6px;\n}\n\n.datasetDropActive {\n  border-style: solid;\n  border-color: var(--curio-category-data-fg);\n  background: var(--curio-category-data-bg);\n}\n\n.datasetName {\n  flex: 1;\n  overflow: hidden;\n  min-width: 0;\n  font-weight: 600;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.datasetHint {\n  flex: 1;\n  min-width: 0;\n  color: var(--curio-text-secondary);\n}\n\n.choices {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0 10px;\n}\n\n.choices .choiceItem {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n  height: var(--widget-h);\n  color: var(--curio-text-primary);\n  font-size: var(--curio-font-size-xs);\n  font-weight: normal;\n}\n\n.multi {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.picks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.pick {\n  composes: chip from \"../../../pages/discovery/DiscoveryAddDialog.module.css\";\n}\n\n.location {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n/* The place search the Discovery dialog shares, at this tab's size. */\n.location > div {\n  gap: 4px;\n  font-size: var(--curio-font-size-xs);\n}\n\n.location > div > button {\n  box-sizing: border-box;\n  height: var(--widget-h);\n  padding: 0 8px;\n  font-size: var(--curio-font-size-xs);\n}\n\n.location p {\n  margin: 0;\n  font-size: 10px;\n}\n\n.places {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 120px;\n  overflow-y: auto;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-sm);\n}\n\n.places button {\n  width: 100%;\n  padding: 3px 6px;\n  border: 0;\n  background: none;\n  color: var(--curio-text-primary);\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.places button:hover {\n  background: var(--curio-surface-muted);\n}\n\n.hint {\n  color: var(--curio-text-secondary);\n}\n\n/* Buttons, at this tab's size: a white one, a dark one for the main action\n   (as ConfirmDialog's), and a red-text one for Delete. */\n.button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  height: var(--widget-h);\n  padding: 0 8px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: var(--curio-radius-sm);\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  font-family: inherit;\n  font-size: var(--curio-font-size-xs);\n  font-weight: 500;\n  line-height: 1;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.button:hover:not(:disabled) {\n  border-color: var(--curio-text-secondary);\n}\n\n.button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.primary {\n  composes: button;\n  border-color: var(--curio-top-bar-bg);\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n  font-weight: 600;\n}\n\n.primary:hover:not(:disabled) {\n  border-color: var(--curio-top-bar-bg-hover);\n  background: var(--curio-top-bar-bg-hover);\n}\n\n.danger {\n  composes: button;\n  color: var(--curio-danger-text);\n}\n\n.danger:hover:not(:disabled) {\n  border-color: var(--curio-danger-border);\n  background: var(--curio-danger-bg);\n}\n\n.add {\n  margin-top: 8px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 6px 0;\n  padding: 8px;\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-md);\n  background: var(--curio-card-bg);\n  box-shadow: var(--curio-shadow-card);\n}\n\n/* A field's name above its input. Not a label Material UI draws in the\n   default's control, which keeps its own row. */\n.form label:not(:global(.MuiFormControlLabel-root)):not(:global(.MuiButton-root)),\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  color: var(--curio-text-secondary);\n  font-size: 10px;\n}\n\n.bounds {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6px;\n}\n\n.formActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 6px;\n}\n\n.problem {\n  color: var(--curio-danger-text);\n  margin: 0;\n}\n\n.problems {\n  color: var(--curio-danger-text);\n  margin: 8px 0 0;\n  padding-left: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tag": `Hw3knxjXkoasYimILvye`,
	"strip": `UlaUSx5jsT2JEMDf9vLa`,
	"stripOpen": `rN1SGZ_JtqIN0jMjK1OF ${___CSS_LOADER_ICSS_IMPORT_0___.locals["thinScrollbar"]}`,
	"categories": `vAUiALMdztjA9XNf0rdz`,
	"category": `a5t1Qz84qUpxpYbAs1at`,
	"categoryCount": `K446mLsFiqyfwLFohFnZ`,
	"chevron": `EFMMbVFQqqr6eNKAALRm`,
	"categoryChips": `y1zXlkdeQAp9hdj8ll_B`,
	"categoryStack": `tr4gOK_DeZDK8Fi22t7m`,
	"inputLine": `ciJBdXeWLOUWwQOaSs1i`,
	"expand": `YC6jANxWKBx3Fx00WGIb`,
	"inputAbout": `pBcbtOu9GzIy0phr7E9_`,
	"inputList": `bp7puGbP4sZapmLuIw24`,
	"listChips": `T3s88faYVjwnkkCUpPXs`,
	"layers": `wSt0H3EF_QSJmLuwexYK`,
	"layerLine": `Utaj4VZRYtz0RilX80vO`,
	"stripHint": `jsthTKfRYHcRDxsa_FLW`,
	"layerEmpty": `NuL91Qbsyi9DGthmG7Zu jsthTKfRYHcRDxsa_FLW`,
	"inputTag": `oWlBgUBH_KewimTPvaQQ Hw3knxjXkoasYimILvye`,
	"layerTag": `ieG6teMw_zGNdeWiSZfA oWlBgUBH_KewimTPvaQQ Hw3knxjXkoasYimILvye`,
	"selectionTag": `lToJOoLLGPnz4ZvmuoDF Hw3knxjXkoasYimILvye`,
	"columnTag": `Yu6FbHmakG1imzheSugT Hw3knxjXkoasYimILvye`,
	"scenarioTag": `W1aPrkdVwxZz28YUyBmk Hw3knxjXkoasYimILvye`,
	"swatches": `lzlZCxRfh2MUU3RtQ_Ou W1aPrkdVwxZz28YUyBmk Hw3knxjXkoasYimILvye`,
	"swatch": `KfF8r5oL63_LWmhhdJvj`,
	"swatchColor": `WrD9dWF4IOom5PiIUDEP`,
	"panel": `bpkehqfEODOlO1QN9GL4 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["thinScrollbar"]}`,
	"panelAboveOutput": `ClFme15r1XZyMr_iuW0x`,
	"empty": `FfV8X7RI2HfoviMbeccE`,
	"row": `NuS4kKSe9ctzycR6tQ6c`,
	"plainRow": `exWlUePopfY08Djtqhfu`,
	"nodeControls": `Vn_4GmKHOBm5V1YN_tFa`,
	"rowLabel": `A8qCF8S48Vw5q2WAoM4w`,
	"rowControl": `CaD2ZXE_JRxEw_tvOWvL`,
	"rowActions": `zF0sHyA8eWo3DZkR1k3K`,
	"shared": `qsdI__DpZl1XPYVCXuvl`,
	"sharedHeading": `dmSi7YYo7TAp0BnvB8wP`,
	"sharedValue": `j00eMdjlEHQdttFPJIsh`,
	"selectionProblem": `IM6JbsDaG59zWzSI3veR`,
	"control": `bTd4pTQ5_qjB8Td_s2xz`,
	"inline": `Zaq5Er8laFIS_A0SseRw`,
	"units": `mi1axHtq8RIAf1V8hu9g`,
	"datasetDrop": `ygou_4aiQHLOmEp6tvln`,
	"datasetDropActive": `l9ZAK7pLemBGga3Gb0Ww`,
	"datasetName": `o5V8RMWDTjXBaXk22ioQ`,
	"datasetHint": `hdnPFCnfRpLNyBHY7sAW`,
	"choices": `aD4ZMz5UzdrHUDabIaOc`,
	"choiceItem": `bc0R4HoK2ZUZCGgaBDgw`,
	"multi": `W1xLpy5ElEBNiV7Tdxdr`,
	"picks": `C565MGxRv3QsFRW6XVYF`,
	"pick": `RvMQIzixFksSmP0PxIgw ${___CSS_LOADER_ICSS_IMPORT_1___.locals["chip"]}`,
	"location": `cUW50wTmpbqquwr1_xiA`,
	"places": `FuSO1SBVzZPY1FPubVX8`,
	"hint": `QeHGBJZ39XC5ltWDLFzi`,
	"button": `GIGzxLs_5GQy6yXqbmEn`,
	"primary": `lU7E5MEFPpdzqjf2aJhn GIGzxLs_5GQy6yXqbmEn`,
	"danger": `hkvh7XWgqv2uv7BbV8MM GIGzxLs_5GQy6yXqbmEn`,
	"add": `kYMKqwfYAUIwRO58h4G3`,
	"form": `oK1IKvieY9Urw9SqLy3Q`,
	"field": `TEMccfVsuVWXjCzyNEpR`,
	"bounds": `Bu9KBcw_JW1Ow2OBxk1W`,
	"formActions": `qenbRU8eRTDN67R0yxzd`,
	"problem": `b3j61ONOKKC1KjjK4ANz`,
	"problems": `sTssxmof4cksU1TzF8Pb`
};
export default ___CSS_LOADER_EXPORT___;
